import { Stack } from "@mui/material";

export const GradeBox = ({
  size = 24,
  grade,
  maxGrade = 5,
  gap = "8px",
}: {
  size?: number;
  grade: number;
  maxGrade?: number;
  gap?: string;
}) => {
  const sizePx = `${size}px`;
  return (
    <Stack flexDirection="row" gap={gap}>
      {Array(maxGrade)
        .fill(1)
        .map((_, i) => (
          <Stack
            key={i}
            gap="8px"
            sx={{
              borderRadius: `${size / 4}px`,
              overflow: "hidden",
              border: "1px solid #FE8836",
              minWidth: sizePx,
              maxWidth: sizePx,
              height: sizePx,
            }}
          >
            <span
              style={{
                width: "100%",
                maxWidth:
                  grade - i > 1
                    ? "100%"
                    : grade - i > 0
                      ? `${(grade - i) * 100}%`
                      : "0",
                height: "100%",
                backgroundColor: "#FE8836",
              }}
            ></span>
          </Stack>
        ))}
    </Stack>
  );
};
